export function formatDate(
  date: any,
  month?: "numeric" | "2-digit" | "long" | "short" | "narrow",
  year?: "numeric" | "2-digit" | "none",
  day?: "numeric" | "2-digit"
) {
  if (!date) return "—";
  if (date.length === 0) {
    return "—";
  }
  let options: Intl.DateTimeFormatOptions = {
    day: day ?? "numeric",
    month: month ?? "long",
  };

  if (year === "none") {
    return new Date(date).toLocaleString("en-GB", options);
  }
  options = { ...options, year: year ?? "numeric" };

  return new Date(date).toLocaleString("en-GB", options);
}

export function formatDateTime(
  date: any,
  month?: "numeric" | "2-digit" | "long" | "short" | "narrow",
  year?: "numeric" | "2-digit",
  day?: "numeric" | "2-digit",
  hour?: "numeric" | "2-digit",
  minute?: "numeric" | "2-digit"
) {
  if (!date) return "—";
  if (date.length === 0) {
    return "—";
  }
  const options: Intl.DateTimeFormatOptions = {
    day: day ?? "numeric",
    month: month ?? "long",
    year: year ?? "numeric",
    hour: hour ?? "numeric",
    minute: minute ?? "numeric",
  };
  return new Date(date).toLocaleString("en-GB", options);
}

export function formatTime(
  date: any,
  hour?: "numeric" | "2-digit",
  minute?: "numeric" | "2-digit"
) {
  if (!date) return "—";
  if (date.length === 0) {
    return "—";
  }
  const options: Intl.DateTimeFormatOptions = {
    hour: hour ?? "numeric",
    minute: minute ?? "numeric",
  };
  return new Date(date).toLocaleString("en-GB", options);
}
